import React from 'react'
import NFLTemplate from 'src/components/page/nfl'
import { teamIds } from 'src/constants/personalizationIds'

export default (props) => {
  return (
    <NFLTemplate
      {...props}
      team="Las Vegas Raiders"
      teamShort="Raiders"
      teamId={teamIds['Las Vegas Raiders']}
    />
  )
}
